import { Col, Form, Row } from "react-bootstrap";
import { IoTrashBin } from "react-icons/io5";
import { Item as ItemModel } from "../../../models/item";
import styleUtils from "../../../styles/utils.module.scss";
import ActionButton from "../../../components/Buttons/Action/ActionButton";

interface ItemProps {
  item: ItemModel;
  onDeleteItemClicked: (item: ItemModel) => void;
}

const Item = ({ item, onDeleteItemClicked }: ItemProps) => {
  const { question, solution } = item;
  return (
    <>
      <Row className={`${"mb-4"} ${"flexCenter"}`}>
        <Col md={5}>
          <Form.Control disabled readOnly defaultValue={question} />
        </Col>
        <Col md={5}>
          <Form.Control disabled readOnly defaultValue={solution} />
        </Col>
        <Col md={1}>
          <ActionButton
            onClick={(e) => {
              onDeleteItemClicked(item);
              e.stopPropagation();
            }}
        >
          <IoTrashBin />
        </ActionButton>
        </Col>
      </Row>
    </>
  );
};

export default Item;
